import FileUploadDialog from "components/FileUploadDialog";

export default class AvatarUploadDialog extends FileUploadDialog {

    show(info, hidCb) {
        this.showComment = false;
        const infoParent = {
            title: "client.uploadAvatar",
            accept: "image/jpeg, image/png",
        };

        super.show(infoParent, hidCb);
    }

    async save() {
        const { selectedFile } = this.state;
        this.hide();

        if (this.hidCb?.apply)
            this.hidCb(selectedFile);
    }

}
